import { LocalizedTranslations } from '../localizedTranslations';

export const sv: LocalizedTranslations = {
  // Navigation
  nav: {
    home: 'Hem',
    europeanMarkets: 'Europeiska Marknader',
    aboutUs: 'Om Oss',
    products: 'Produkter',
    oemSolutions: 'OEM-lösningar',
    blog: 'Blogg',
    clientHub: 'Kundportal',
    agentLogin: 'Agentinloggning',
    contact: 'Kontakt',
    getStarted: 'Kom Igång',
    smartToilets: 'Smarta Toaletter',
    businessSolutions: 'Affärslösningar',
    technology: 'Teknik',
    about: 'Om Oss',
    viewAllProducts: 'Visa Alla Produkter',
    flagship: 'Flaggskepp',
    productDescriptions: {
      rem7: 'Vår Främsta Smarta Toalett',
      luxa: 'Ultimat Lyxlinje',
      luna: 'Kompakt Minimalistisk',
      nova: 'Familje Smart Toalett',
      aria: 'Eko-Lyx Design',
      vena: 'Premium Bidé',
      aurelius: 'Klassisk Elegans',
      aurelux: 'Guldaccentuerad Utgåva',
      luma: 'Smart Innovation',
    },
  },
  
  // Common
  common: {
    learnMore: 'Läs Mer',
    viewDetails: 'Visa Detaljer',
    requestQuote: 'Begär Offert',
    downloadCatalog: 'Ladda Ner Katalog',
    contactUs: 'Kontakta Oss',
    readMore: 'Läs Mer',
    seeAll: 'Se Alla',
    back: 'Tillbaka',
    next: 'Nästa',
    previous: 'Föregående',
    submit: 'Skicka',
    send: 'Skicka',
    close: 'Stäng',
    loading: 'Laddar...',
    error: 'Fel',
    success: 'Framgång',
  },
  
  // Homepage
  home: {
    heroTitle: 'Premium Smarta Toaletter för Europeiska Marknader',
    heroSubtitle: 'Upplev framtidens badrumslyx med intelligent design och banbrytande teknik',
    exploreCollection: 'Utforska Kollektionen',
    watchVideo: 'Se Video',
    featuredProducts: 'Utvalda Produkter',
    whyChooseUs: 'Varför Välja Aureum VII Trading',
    testimonials: 'Vad Våra Kunder Säger',
    certifications: 'Certifieringar & Standarder',
  },
  
  // Products
  products: {
    title: 'Vår Kollektion av Smarta Toaletter',
    subtitle: 'Upptäck vårt sortiment av premium intelligenta badrumsösningar',
    features: 'Funktioner',
    specifications: 'Tekniska Specifikationer',
    installation: 'Installationsguide',
    warranty: 'Garantiinformation',
    dimensions: 'Dimensioner',
    waterUsage: 'Vattenförbrukning',
    powerConsumption: 'Strömförbrukning',
    weight: 'Vikt',
    material: 'Material',
    certification: 'Certifiering',
    relatedProducts: 'Relaterade Produkter',
  },
  
  // Contact
  contact: {
    title: 'Kontakta Oss',
    subtitle: 'Vi vill gärna höra från dig. Skicka oss ett meddelande så svarar vi så snart som möjligt.',
    name: 'Fullständigt Namn',
    email: 'E-postadress',
    phone: 'Telefonnummer',
    company: 'Företagsnamn',
    message: 'Ditt Meddelande',
    sendMessage: 'Skicka Meddelande',
    ourLocation: 'Vår Plats',
    emailUs: 'Maila Oss',
    callUs: 'Ring Oss',
    businessHours: 'Öppettider',
    weekdays: 'Måndag - Fredag: 09:00 - 18:00',
    weekend: 'Lördag - Söndag: Stängt',
  },
  
  // About
  about: {
    title: 'Om Aureum VII Trading',
    subtitle: 'Din pålitliga partner för premium smarta toalettlösningar i Europa',
    ourStory: 'Vår Historia',
    ourMission: 'Vårt Uppdrag',
    ourVision: 'Vår Vision',
    ourValues: 'Våra Värderingar',
    quality: 'Kvalitet',
    innovation: 'Innovation',
    sustainability: 'Hållbarhet',
    customerFocus: 'Kundfokus',
  },
  
  // Footer
  footer: {
    description: 'Premium smarta toalettlösningar för den europeiska marknaden. Upplev lyx, innovation och hållbarhet.',
    quickLinks: 'Snabblänkar',
    products: 'Produkter',
    support: 'Support',
    legal: 'Juridiskt',
    privacyPolicy: 'Integritetspolicy',
    termsConditions: 'Allmänna Villkor',
    returnPolicy: 'Returpolicy',
    shippingPolicy: 'Fraktpolicy',
    allRightsReserved: 'Alla rättigheter förbehållna.',
    followUs: 'Följ Oss',
  },
  
  // Forms
  forms: {
    required: 'Detta fält är obligatoriskt',
    invalidEmail: 'Ange en giltig e-postadress',
    invalidPhone: 'Ange ett giltigt telefonnummer',
    messageSent: 'Ditt meddelande har skickats!',
    errorSending: 'Ett fel uppstod vid sändning av ditt meddelande. Vänligen försök igen.',
  },
  
  // FAQ
  faq: {
    title: 'Vanliga Frågor',
    subtitle: 'Hitta svar på vanliga frågor om våra smarta toaletter',
    stillHaveQuestions: 'Har du fortfarande frågor?',
    contactSupport: 'Kontakta vårt supportteam',
  },
  
  // Blog
  blog: {
    title: 'Senaste Artiklarna',
    subtitle: 'Håll dig uppdaterad med de senaste trenderna inom smart badrumstek',
    readingTime: 'min läsning',
    author: 'Av',
    publishedOn: 'Publicerad',
    categories: 'Kategorier',
    tags: 'Taggar',
    relatedArticles: 'Relaterade Artiklar',
  },
  
  // Meta/SEO
  meta: {
    homeTitle: 'Smarta Toaletter | Aureum VII Trading',
    homeDescription: 'B2B-leverantör av lyxiga smarta toaletter, badkar i solid surface, massagebad och kommoder till byggherrar, hotell och arkitekter i Europa. CE-certifierat.',
    productsTitle: 'Kollektion av Smarta Toaletter | Aureum VII',
    productsDescription: 'Utforska hela REM7-sortimentet: tanklös direktvärmning, uppvärmda bidésitsar och UV-sterilisering. CE-certifierat och tillgängligt i projektvolym.',
    contactTitle: 'Kontakt & Företagsförfrågningar | Aureum VII',
    contactDescription: 'Kontakta Aureum VII Trading i Marbella om leverans av smarta toaletter och badrumsinredning — partipriser, MOQ, OEM och leverans inom EU.',
    aboutTitle: 'Om Aureum VII Trading | Leverantör i Europa',
    aboutDescription: 'Aureum VII Trading levererar lyxiga smarta toaletter och badrumsprodukter från Marbella till byggherrar, hotell och arkitekter i hela Europa.',
    defaultTitle: 'Aureum VII Trading | Lyxiga Smarta Toaletter',
    defaultDescription: 'Premium smarta toaletter och badrumsprodukter med uppvärmda sitsar, bidéfunktioner och smart styrning — levereras i hela Europa av Aureum VII Trading.',
    rem7Title: 'REM7 — Flaggskeppet Bland Smarta Toaletter',
    rem7Description: 'REM7 är Aureum VII Tradings flaggskepp: integrerad bidé, direktvärmning, UV-sterilisering och ekoläge. Specialerbjudande: 600 € per enhet.',
    luxaTitle: 'LUXA — Lyxig Smart Toalett | Aureum VII',
    luxaDescription: 'LUXA förenar europeisk design med avancerad teknik: bidé med justerbar temperatur, LED-nattljus och UV-sterilisering. Specialerbjudande: 600 € per enhet.',
    bathSanitaryTitle: 'Lyxiga Badkar & Sanitet | Aureum VII',
    bathSanitaryDescription: 'B2B-katalog med badkar, massagebad, tvättställ och exklusiva badrumsmöbler. Volympriser för hotell, byggherrar och arkitekter i hela Europa.',
    businessTitle: 'B2B-Lösningar för Hotell & Byggherrar',
    businessDescription: 'Volympriser, OEM-stöd och logistik i hela Europa för arkitekter, hotell och fastighetsutvecklare. Begär en företagsoffert från Aureum VII Trading.',
    compareTitle: 'Jämför Smarta Toaletter | Aureum VII',
    compareDescription: 'Jämför funktioner, priser och specifikationer för alla REM7-modeller sida vid sida och hitta rätt smart toalett för ditt projekt.',
    faqTitle: 'Vanliga Frågor | Aureum VII Trading',
    faqDescription: 'Svar om installation, garanti, underhåll och priser för REM7 smarta toaletter. Allt du behöver veta innan du beställer.',
  },
  
  // Product Pages
  productPages: {
    luna: {
      title: 'LUNA M9 Lyxig Smart Toalett | Wellness Spa-Teknik',
      description: 'Upptäck LUNA M9 smart toalett med omedelbar uppvärmning, digital display, terapeutisk spa-rengöring och wellness-funktioner.',
      heroTitle: 'LUNA',
      heroSubtitle: 'Modell M9',
      heroDescription: 'LUNA M9 lyxig smart toalett kombinerar tidlös elegans med avancerad wellness-fokuserad funktionalitet.',
      features: {
        heatedSeat: 'Uppvärmt säte med nattljus',
        washModes: 'Flera tvättlägen',
        dryingFunction: 'Smart torkfunktion',
        modernDesign: 'Smal modern design',
      },
      cta: {
        downloadSpec: 'Ladda Ner Specifikationer',
        backToCollections: '← Tillbaka till Kollektioner',
        requestQuote: 'Begär Offert',
      },
    },
    luxa: {
      title: 'LUXA M80 Flaggskepps Smart Toalett | Premium Bidet-System',
      description: 'LUXA M80 flaggskepps smart toalett med rörelsesensorer, tanklös uppvärmning, UV-sterilisering och premium-automation.',
      heroTitle: 'LUXA',
      heroSubtitle: 'Modell: M80',
      heroDescription: 'LUXA M80 är flaggskeppet i vår premium-kollektion och representerar höjdpunkten av intelligent badrumsinnovation.',
      features: {
        motionSensor: 'Lock med rörelsesensor',
        tanklessHeating: 'Tanklös omedelbar uppvärmning',
        adjustableTemp: 'Justerbar vattentemperatur & tryck',
        premiumCeramic: 'Premium-keramik + mjukt stängande lock',
        ecoDesign: 'Miljövänlig design',
      },
      cta: {
        downloadSpec: 'Ladda Ner Specifikationer',
        backToCollections: '← Tillbaka till Kollektioner',
        requestQuote: 'Begär Offert',
      },
    },
    aria: {
      title: 'ARIA H60 Väggmonterad Smart Toalett | Utrymmesbesparande Design',
      description: 'ARIA H60 arkitektonisk väggmonterad smart toalett med elegant design, avancerad bidet-teknik och utrymmesbesparande installation.',
      heroTitle: 'ARIA',
      heroSubtitle: 'Modell H60',
      heroDescription: 'ARIA H60 betonar minimalistisk arkitektonisk design med maximal komfort och intelligent funktionalitet.',
      features: {
        bidetSpray: 'Justerbar bidet-stråle',
        waterSaving: 'Vattenbesparande teknik',
        compactFit: 'Kompakt passform för små badrum',
        softClose: 'Mjukt stängande lock',
      },
      cta: {
        downloadSpec: 'Ladda Ner Specifikationer',
        backToCollections: '← Tillbaka till Kollektioner',
        requestQuote: 'Begär Offert',
      },
    },
  },
};
